/**
 * RTK Query API slice for Feedback endpoints
 * POST /apps/public-websearch-chatbot-client/api/v1/feedback
 *
 * Includes error handling and proper TypeScript typing.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { FeedbackRequest, FeedbackResponse } from '../../types/feedback';

/**
 * Feedback API slice using RTK Query
 * Provides mutation for submitting user feedback on chatbot messages
 */
export const feedbackApi = createApi({
  reducerPath: 'feedbackApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/apps/public-websearch-chatbot-client/api/v1',
  }),

  // Cache tags for invalidation
  tagTypes: ['Feedback'],

  endpoints: (builder) => ({
    /**
     * Submit feedback for a message
     * Mutation endpoint that submits user feedback with message and result
     */
    submitFeedback: builder.mutation<FeedbackResponse, FeedbackRequest>({
      query: (feedback) => ({
        url: 'feedback',
        method: 'POST',
        body: feedback,
      }),
      invalidatesTags: ['Feedback'],
    }),
  }),
});

// Export hooks for use in components
export const { useSubmitFeedbackMutation } = feedbackApi;
